// useAuth.js - The custom hook that ties everything together
import { useDispatch, useSelector } from "react-redux";
import { setCredentials, logout } from "../store/authSlice";
import { useLoginMutation } from "../services/user";
import { useNavigate } from "react-router-dom";

export function useAuth() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { token, isAuthenticated, userData } = useSelector(
    (state) => state.auth
  );

  const [loginMutation, { isLoading: isLoginLoading }] = useLoginMutation();

  // Login function that stores the token
  const login = async (credentials) => {
    try {
      const result = await loginMutation(credentials).unwrap();
      dispatch(setCredentials(result));
      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  // Logout function
  const logoutUser = () => {
    dispatch(logout());
    navigate("/login");
  };

  const getUserInfo = () => {
    if (!userData) return null;

    return {
      name: userData.userName,
      id: userData.userGlid,
      sessionNumber: userData.sessionNumber,
      loginTime: new Date(userData.loginDate),
    };
  };

  return {
    token,
    isAuthenticated,
    userData,
    userInfo: getUserInfo(),
    login,
    logout: logoutUser,
    isLoading: isLoginLoading,
  };
}
